// About this data
// This data is used for creating header and menu in this differents versions (the design changes slightly as per the page we're in)
// "overshoot" controls the negative margin applied to Menu Words starting with curved letters (as C or O), to optically align items in mobile version of navigation 
// "mainManu" specific items that are in main navigation in opposition to those that aren't (e.g. Manifiesto is out of main menu)

export const navigationData = [
    {
        text:'Cronología',
        link:'/cronologia',
        image:'menu_story.png',
        color:'brand05',
        overshoot: true,
        mainMenu: true,
        mobileMenu: true
    },
    {
        text:'Visualización',
        link:'/visualizacion',
        image:'menu_dash.png',  
        color:'brand02',
        textColor: 'text06',
        mainMenu: true,
        mobileMenu: false
    },
    {
        text:'Datos',
        link:'/datos',
        image:'menu_api.png',
        color:'brand06',
        textColor: 'text06',
        mainMenu: true,
        mobileMenu: true
    },
    // {
    //     text:'Contexto',
    //     link:'/storytelling',
    //     image:'menu_story.png',
    //     color:'brand04',
    //     overshoot: true,
    //     mainMenu: true
    // },
    {
        text:'Recursos',
        link:'/recursos',
        image:'menu_source.png',
        color:'brand03',
        mainMenu: true,
        mobileMenu: true
    },
    {
        text: 'Manifiesto',
        link: '/manifiesto',
        image: 'menu_story.png',
        color: 'brand07',
        mainMenu: false,
    }
];


export const getNavigationData = (path) => {
    let found = false;
    navigationData.find(itemData => {
      if (path && path.includes(itemData.link) ) {
          found = itemData
          return null;
    }})
    return found
}
  
